var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23177 12.7687C10.4534 12.7687 13.0651 10.157 13.0651 6.93538C13.0651 3.71372 10.4534 1.10205 7.23177 1.10205C4.01011 1.10205 1.39844 3.71372 1.39844 6.93538C1.39844 10.157 4.01011 12.7687 7.23177 12.7687ZM5.43156 9.60019C5.62841 9.83416 5.90194 9.96872 6.18317 9.96872C6.46342 9.96841 6.73665 9.83351 6.93252 9.59979L10.2717 5.62087C10.5141 5.33158 10.5114 4.86596 10.2658 4.58078C10.0194 4.29528 9.6234 4.29849 9.3805 4.58778L6.18165 8.39973L4.80265 6.75692C4.56051 6.46794 4.16404 6.46504 3.91788 6.75017C3.67199 7.03505 3.66951 7.50071 3.91192 7.78995L5.43156 9.60019Z",
    fill: "#F7FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedStatus);
export default __webpack_public_path__ + "static/media/CompletedStatus.a0afbb37422b529f2beb458771adeeca.svg";
export { ForwardRef as ReactComponent };